module.exports = __webpack_public_path__ + "img/milano.f9167291.jpg";